import { gql } from '@apollo/client'

export const CREATE_PROFORMA_MUTATION = gql`
  mutation CreateProforma($transactionIDs: [ID!]!) {
    createProforma(transactionIDs: $transactionIDs) {
      proformaID
      proformaNumber
      message
    }
  }
`

export const CONFIRM_PROFORMA_MUTATION = gql`
  mutation ConfirmProforma($proformaID: ID!) {
    confirmProforma(proformaID: $proformaID) {
      message
    }
  }
`

export const ONLINE_PAYMENT_OF_PROFORMA_MUTATION = gql`
  mutation OnlinePaymentOfProforma($proformaID: ID!) {
    onlinePaymentOfProforma(proformaID: $proformaID) {
      trackingID
    }
  }
`

export const OFFLINE_PAYMENT_OF_PROFORMA_MUTATION = gql`
  mutation OfflinePaymentOfProforma($input: OfflinePaymentOfProformaInput!) {
    offlinePaymentOfProforma(input: $input) {
      message
    }
  }
`

export const CONFIRM_OFFLINE_PAYMENT_OF_PROFORMA_MUTATION = gql`
  mutation ConfirmOfflinePaymentOfProforma(
    $input: ProformaActionWithDescriptionInput!
  ) {
    confirmOfflinePaymentOfProforma(input: $input) {
      trackingID
    }
  }
`

export const REJECT_OFFLINE_PAYMENT_OF_PROFORMA_MUTATION = gql`
  mutation RejectOfflinePaymentOfProforma(
    $input: ProformaActionWithDescriptionInput!
  ) {
    rejectOfflinePaymentOfProforma(input: $input) {
      message
    }
  }
`

export const CANCEL_PROFORMA_MUTATION = gql`
  mutation CancelProforma($proformaID: ID!) {
    cancelProforma(proformaID: $proformaID) {
      message
    }
  }
`

export const RETRY_PAYMENT_OF_PROFORMA_MUTATION = gql`
  mutation RetryPaymentOfProforma($proformaID: ID!) {
    retryPaymentOfProforma(proformaID: $proformaID) {
      newProformaID
    }
  }
`
export const GET_PREVIEW_OF_REFRESHED_PROFORMA = gql`
  query GetPreviewOfRefreshedProforma($proformaID: ID!) {
    getPreviewOfRefreshedProforma(proformaID: $proformaID) {
      transactions {
        transaction {
          transactionID
          walletID
          type
          status
          amount
          amount
          time
          description
          relatedTransactionIDs
          userID
          createdAt
          updatedAt
          creditorID
          correlationID
          serviceID
          requestTime
          paymentStatus
          dueDate
          paymentTermID
          proformaID
          usedBalanceType
          sumOfPenalty
          rewardOfEarlyPayment
          reservationNumber
          creditorEntity {
            entityType
            entityID
            entityCode
            entityName
            displayEntityCode
          }
          currency
        }
        penalties {
          transactionID
          walletID
          type
          status
          amount
          amount
          time
          description
          relatedTransactionIDs
          userID
          createdAt
          updatedAt
          creditorID
          correlationID
          serviceID
          requestTime
          paymentStatus
          dueDate
          paymentTermID
          proformaID
          usedBalanceType
          sumOfPenalty
          rewardOfEarlyPayment
          reservationNumber
          creditorEntity {
            entityType
            entityID
            entityCode
            entityName
            displayEntityCode
          }
          currency
        }
      }
      totalAmountOfPayment
      previousAmountOfPayment
    }
  }
`
